import {getRequest, postRequest} from "./AxiosConfig";

export async function getTaskFeedback(id, answer, setErrorMessage){
    return await postRequest( "/ai/question_task", setErrorMessage, {id: id, answer: answer});
}

export async function evaluateUser(setErrorMessage){
    return await getRequest( "/ai/user/evaluate", setErrorMessage);
}